export abstract class BaseDO {
    protected abstract getPrimitivePropertyKeys(): string[];

    protected getObjectPropertyEnsureUndefined(object: object, propertyName: string): object {
        if (!object || !object[propertyName]) {
            return null;
        }
        return object[propertyName];
    }

    public buildFromObject(object: object) {
        if (!object) {
            return;
        }
        const primitiveProperties: string[] = this.getPrimitivePropertyKeys();
        primitiveProperties.forEach((property: string) => {
            if (object.hasOwnProperty(property)) {
                this[property] = object[property];
            }
        });
    }

    protected forEachElementOf(list: any, iteratee: (element: object) => void) {
        if (!Array.isArray(list)) {
            return;
        }
        list.forEach((element: object) => {
            iteratee(element);
        });
    }
}
